<template>
  <div :style="divStyle"  style="height:100%;" >
    <!--------------登录页开始------------------->
    <div v-if="dialogVisible" class="login-overlay">
      <el-dialog
        align="center"
        :visible.sync="dialogVisible"
        width="450px"
        @close="clearForm"
        :close-on-click-modal="false"
        :modal="false"
        custom-class="login-dialog"
        :show-close="true">
        <div slot="title" class="login-dialog-title">
          <h2 style="margin: 0; color: #004499; font-weight: 600;">HLS-Ⅱ Operation Status</h2>
        </div>
        <el-tabs v-model="activetabName" class="login-tabs">
        <el-tab-pane label="NSRL统一身份认证" name="NSRL">
            <el-form style="width: 100%;height:280px;padding: 20px 30px;max-width: 350px;margin: 0px auto;" :model="loginForm"  ref="loginForm">
              <el-form-item style="text-align: center; margin-top: 20px;">
                <!-- 统一身份认证图标 -->
                <div class="cas-icon-wrapper">
                  <div class="icon-circle">
                    <i class="el-icon-user-solid" style="font-size: 60px; color: #409EFF;"></i>
                  </div>
                </div>
                <!-- 统一身份认证登录按钮 -->
               <!-- <a href="https://nsrloa.ustc.edu.cn/cas/login?service=http://192.168.125.199:8080/hlsTS/casCallback" style="text-decoration: none;">-->
                    <a href="https://nsrloa.ustc.edu.cn/cas/login?service=http://202.38.77.8/hlsTS/casCallback" style="text-decoration: none;">
                
                  <el-button type="primary" size="large" class="cas-login-btn">
                    <i class="el-icon-right"></i> NSRL统一身份认证登录
                  </el-button>
                </a>
                <p style="color: #909399; font-size: 12px;">使用NSRL统一身份认证账号登录</p>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="系统账号登录" name="系统账号登录">
            <el-form style="width: 100%; padding: 25px 30px; max-width: 350px; margin: 0 auto;" :model="loginForm"  ref="loginForm" label-width="70px">
              <el-form-item label="用户名" required prop="username">
                <el-input
                  v-model="loginForm.username"
                  required
                  placeholder="请输入用户名"
                  prefix-icon="el-icon-user"
                  clearable></el-input>
              </el-form-item>
              <el-form-item label="密码" required prop="password">
                <el-input
                  type="password"
                  required
                  v-model="loginForm.password"
                  show-password
                  @keyup.enter.native="login('loginForm')"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"></el-input>
              </el-form-item>
              <el-form-item label="" style="color: #F56C6C; font-size: 13px;" :hidden="tipHidden">
                <i class="el-icon-warning"></i> 登录失败，请检查用户名和密码
              </el-form-item>
              <el-form-item label="" align="right" style="margin-bottom: 10px;">
                <span class="link-text" @click="forgetPassword">忘记密码</span>
                <span style="color: #DCDFE6; margin: 0 5px;">|</span>
                <span class="link-text" @click="loginMatter">无法登录</span>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button type="primary" @click="login('loginForm')" class="full-width-btn" size="large">
                  <i class="el-icon-right"></i> 系统账号登录
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="注册" name="注册">
            <el-form style="width: 100%; padding: 25px 30px; max-width: 360px; margin: 0 auto;" :model="signUpForm" :rules="rules" ref="signUpForm" label-width="80px">
              <el-form-item label="用户名" prop="username" required>
                <el-input
                  v-model="signUpForm.username"
                  required
                  placeholder="例如：yiWang、王一"
                  prefix-icon="el-icon-user"
                  clearable></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password" required>
                <el-input
                  type="password"
                  v-model="signUpForm.password"
                  maxlength="20"
                  autocomplete="off"
                  required
                  placeholder="8-20位包含数字、大小写字母"
                  prefix-icon="el-icon-lock"
                  show-password></el-input>
                <el-progress :percentage="passwordPercent" :format="passwordPercentFormat" :color="customColorMethod" style="margin-top: 8px;"></el-progress>
              </el-form-item>
              <el-form-item label="确认密码" prop="checkPass" required>
                <el-input
                  type="password"
                  v-model="signUpForm.checkPass"
                  required
                  placeholder="请再次输入密码"
                  prefix-icon="el-icon-lock"
                  show-password></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email" required>
                <el-input
                  v-model="signUpForm.email"
                  required
                  placeholder="例如：yfgan@ustc.edu.cn"
                  prefix-icon="el-icon-message"
                  clearable></el-input>
              </el-form-item>
              <el-form-item label="验证码" required prop="identifyValid">
                <div style="display: flex; align-items: center;">
                  <el-input
                    v-model="signUpForm.identifyValid"
                    required
                    placeholder="请输入验证码"
                    style="flex: 1;"
                    @keyup.enter.native="signUp('signUpForm')"
                    prefix-icon="el-icon-key"></el-input>
                  <div class="identify" @click="refreshCode('identifyCode')" style="margin-left: 10px;">
                    <sidentify id="signId" :identifyCode="identifyCode"></sidentify>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button type="primary" @click="signUp('signUpForm')" class="full-width-btn" size="large">
                  <i class="el-icon-check"></i> 立即注册
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>
    <!--------------登录页结束------------------->
    <!--------------忘记密码开始------------------->
    <div v-if='dialogForgetPassword'>
      <el-dialog
        title="找回密码"
        :visible.sync="dialogForgetPassword"
        width="420px"
        @close="clearForm"
        :close-on-click-modal="false"
        :modal="false"
        custom-class="forget-password-dialog">
        <div slot="title" class="dialog-custom-title">
          <i class="el-icon-key" style="font-size: 20px; color: #409EFF; margin-right: 8px;"></i>
          <span style="font-size: 18px; font-weight: 600; color: #303133;">通过邮件找回密码</span>
        </div>
        <el-form style="width: 100%; padding: 10px 30px; max-width: 340px; margin: 0 auto;" :model="forgetForm" :rules="rules" ref="forgetForm">
          <div style="text-align: center; margin-bottom: 20px;">
            <i class="el-icon-message" style="font-size: 60px; color: #409EFF;"></i>
            <p style="color: #909399; font-size: 13px; margin-top: 10px;">请输入您的注册邮箱，我们将发送密码重置链接</p>
          </div>
          <el-form-item label="" prop="email" required>
            <el-input
              v-model="forgetForm.email"
              required
              placeholder="请输入邮箱"
              prefix-icon="el-icon-message"
              clearable
              size="large"></el-input>
          </el-form-item>
          <el-form-item label="" required prop="identifyValidForget">
            <div style="display: flex; align-items: center;">
              <el-input
                v-model="forgetForm.identifyValidForget"
                required
                placeholder="请输入验证码"
                style="flex: 1;"
                @keyup.enter.native="togetPassword('forgetForm')"
                prefix-icon="el-icon-key"
                size="large"></el-input>
              <div class="identify" @click="refreshCode('identifyCodeForget')" style="margin-left: 10px; height: 40px;">
                <sidentify id="forgetId" :identifyCode="identifyCodeForget"></sidentify>
              </div>
            </div>
          </el-form-item>
          <el-form-item align="center" style="margin-top: 30px; margin-bottom: 10px;">
            <el-button type="primary" @click="togetPassword('forgetForm')" class="full-width-btn" size="large">
              <i class="el-icon-check"></i> 确定
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <!--------------忘记密码结束------------------->
    <!--------------修改密码页面开始------------------->
    <el-dialog align="center" :visible.sync="dialogVisibleEdit" width="280px"  :close-on-press-escape="false"
               :show-close="true" :close-on-click-modal="false" :before-close="handleClose">
      请填入您的信息
      <el-form style="width: 100%" :rules="rules" status-icon :ref="userInfoForm" :model="userInfoForm">
        <el-form-item label="用户名" prop="name">
          <el-input v-model="userInfoForm.name" disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="fullName">
          <el-input v-model="userInfoForm.fullName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="新的密码" prop="password">
          <el-input type="password" v-model="userInfoForm.password" show-password placeholder="密码长度不小于八位"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passwordEnsure" >
          <el-input type="password" v-model="userInfoForm.passwordEnsure" show-password @keyup.enter.native="login" placeholder="请确认密码"></el-input>
        </el-form-item>
        <el-form-item label="" style="color: red" :hidden="editTipHidden">请按正确格式填写信息</el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editUserInfo" plain >提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--------------修改密码页面结束------------------->
    <!--------------网页头部开始------------------->
    <div class="content">
      <div class="headerBox" style="width:1440px;margin:auto;" v-if="showNavBar">
        <el-row style=" height:120px;"  type="flex" justify="center">
          <el-col :span=8  align="center" style="margin-bottom: 0; margin-top: 20px;position:relative;">
          </el-col>
          <el-col :span=8  align="center">
            <p class="grid-content bg-purple-dark" style="font-size: xx-large; margin-top: 20px;" >
              <font style="font-size: xx-large;font-weight: bold;font-family: Arial, Helvetica, sans-serif; color: #004499">HLS-Ⅱ Operation Status</font>
            </p>
          </el-col>
          <el-col :span=8  align="center" style="margin-bottom: 0; margin-top: 5px;">
            <div class="userInfo" style="float:right;position:absolute;right:0px;top:60px;">
              <!-- 已登录时显示：用户图标 + 用户名 + Log out -->
              <span :hidden="userNowHidden" style="display: inline-flex; align-items: center; justify-content: center;"><i class="el-icon-user-solid"></i></span>
              <span style="font-size: medium; color: #67c23a; font-weight: bold; margin-left: 5px; margin-right: 10px" :hidden="userNowHidden">{{userNow}}</span>
              <!-- 未登录时显示：Log in / 注册；已登录时显示：Log out -->
              <span  @click="loginClick"  style="font-size:16px;font-weight:bolder;color: rgb(0, 68, 153);cursor: pointer;">{{loginOption}}</span>
              <span  :hidden="!userNowHidden"  style="color: rgb(0, 68, 153);font-weight: bold;font-size:16px;">/</span>
              <span :hidden="!userNowHidden" @click="loginClick('注册')" size="small" style="font-size:16px;font-weight:bolder;color: rgb(0, 68, 153);cursor: pointer;">注册</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
        <!--------------网页头部结束------------------->
              <!--导航栏  使用router模式-->
            <el-row type="flex" justify="center" class="menu-flex">
              <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#004499"
                      text-color="#ffffff"
                      active-text-color="#ffd04b"
                      @select="select">
                <el-col  :span="3" align="center" class="menu-item-box">
                  <div class="logo" style="float:left;width:80px;height:80px;position:absolute;left:0;top:-110px;"> <img width="100%" height="100%" src="/static/picture/nsrl_logo2.jpg"></div>
                  <p style="color: #2d6ba9;font-size: large;float:left;position:absolute;left:90px;top:-52px;" >{{timeNow}}</p>
                  <el-menu-item  align="center"></el-menu-item>
                </el-col>
                <el-col  :span="3" align="center" class="menu-item-box">
                  <el-menu-item index="/home" align="center">Operation Status</el-menu-item>
                </el-col>
                <el-col :span="3.5" align="center" class="menu-item-box">
                  <div :hidden="routeHidden">
                    <el-submenu index="/history" align="center">
                      <template slot="title" style="width: 100%;"><font style="font-size: large;font-weight: bold;font-family: Arial, Helvetica, sans-serif;width: 100%;">Historical Data</font></template>
                      <el-menu-item index="/history/customizedquery">Customized Query</el-menu-item>
                      <el-menu-item index="/history/freequery">Free Query</el-menu-item>
                    </el-submenu>
                  </div>
                </el-col>
                <el-col :span="3.5" align="center" class="menu-item-box">
                  <el-submenu index="3" align="center" style="width: 100%" :hidden="routeHidden">
                    <template slot="title" style="width: 100%"><font style="font-size: large;">Data Analysis</font></template>
                    <el-menu-item index="/analysis/operstatstatistics" style="width: 100%">Oper Stat Statistics</el-menu-item>
                    <el-menu-item index="/analysis/operstatlist">Oper Stat List</el-menu-item>
                    <el-menu-item index="/analysis/integral">Integral Current</el-menu-item>
                    <el-menu-item index="/analysis/beamcleaning">Beam Cleaning</el-menu-item>
                    <el-menu-item index="/analysis/beamlineOperStatics">Beamline Oper Statics</el-menu-item>
                  </el-submenu>
                </el-col>
                <el-col :span="3" align="center" class="menu-item-box">
                  <el-menu-item index="/radiation" align="center" :hidden="routeHidden">Radiation Monitor</el-menu-item>
                </el-col>
                <el-col :span="3.5" align="center" class="menu-item-box">
                  <el-menu-item index="/alarm" align="center" :hidden="routeHidden">Alarm Information</el-menu-item>
                </el-col>
                <el-col :span="3.5" align="center" class="menu-item-box">
                  <el-submenu index="4" :hidden="routeHidden">
                    <template slot="title"><font style="font-size: large;">Miscellaneous</font></template>
                    <el-submenu index="4-1">
                      <template slot="title" :hidden="!(!routeHidden && isManage)"><font style="font-size: large;">User Management</font></template>
                      <!--<el-menu-item index="/userManagement/whiteIpList" :hidden="!(!routeHidden && isManage)">White IP List</el-menu-item>-->
                      <el-menu-item index="/userManagement/userManagement" :hidden="!(!routeHidden && isManage)">User Management</el-menu-item>
                      <el-menu-item index="/userManagement/registerManagement" :hidden="!(!routeHidden && isManage)">Register Management</el-menu-item>
                      <el-menu-item index="/userManagement/viewLog" :hidden="!(!routeHidden && isManage)">View Log</el-menu-item>
                      <!--<el-menu-item index="/userManagement/changeUserInfo" :hidden="routeHidden">Change User Info</el-menu-item>-->
                      <el-menu-item index="/userManagement/changePassword" :hidden="routeHidden">Change Password</el-menu-item>
                      <!--<el-menu-item index="/userManagement/viewLog" :hidden="routeHidden">View Log</el-menu-item>-->
                    </el-submenu>
                    <!-- <el-menu-item index="/pvManagement/pvManagement" :hidden="!(!routeHidden && isManage)">PV Management</el-menu-item> -->
                    <!-- <el-menu-item index="/getsource" :hidden="!(!routeHidden && isManage)">Data Source</el-menu-item> -->
                    <!-- <el-menu-item index="/Metrics/metrics" :hidden="!(!routeHidden && isManage)">AA Performance</el-menu-item> -->
                    <el-menu-item index="/about" :hidden="routeHidden">About</el-menu-item>
                  </el-submenu>  
                </el-col>
                <el-col  :span="3.5" align="center" class="menu-item-box">
                </el-col>
              </el-menu>
            </el-row>
          </el-row>
      </div>
      <div class="wrapBox" :class="{paddingno:isShowPaddingno}">
          <el-row>
            <div>
              <!-- 路由匹配到的组件将渲染在这里 -->
              <router-view></router-view>
            </div>
          </el-row>
      </div>
    </div>
    <el-footer class="footBox" v-if="showFooter">
      <div>
       <!-- <div align="center">
          <div>Copyright Information Technology Division, NSRL<b/></div>
          <div>地址：安徽省合肥市合作化南路42号 &nbsp;&nbsp; 邮编：230029<b/></div>
        </div>-->
      </div>
      <div>欢迎您的光临！您是本站第<span style="margin: 0 3px;">{{visitorCounter}}</span>位访问者</div>
    </el-footer>

  </div>
</template>

<script>
import sidentify from '@/components/identify.vue'
  export default {
    name: 'app',
    components:{
      sidentify
    },
    data() {
      
      //密码验证
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else{
          callback();
        }
      };

      let validateFullName = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('姓名不能为空'))
        }else {
          callback()
        }
      }

      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.userInfoForm.password) {
          callback(new Error('两次输入密码不一致!'));
        }
      };
      var identifyValidPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('verification code is required'));
        } else if (value.toUpperCase() !== this.identifyCode) {
          callback(new Error('correct verification code is required'));
        } else {
          callback();
        }
      };
      var identifyValidPassForget = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('verification code is required'));
        } else if (value.toUpperCase() !== this.identifyCodeForget) {
          callback(new Error('correct verification code is required'));
        } else {
          callback();
        }
      };
      var  validateSignPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('password is required'));
          this.passwordPercent = 0;
        } else{
          //密码验证
          var ls = 0;
          if(this.signUpForm.password !== ''){
            if(this.signUpForm.password.match(/([a-z])+/)){
              ls++;
            }
            if(this.signUpForm.password.match(/([0-9])+/)){
              ls++;
            }
            if(this.signUpForm.password.match(/([A-Z])+/)){
              ls++;
            }
            if(this.signUpForm.password.match(/([\W])+/) && !this.signUpForm.password.match(/(![\u4E00-\u9FA5])+/)){  
              callback(new Error('不能包含特殊字符'));
              ls=0;
            }
            if(this.signUpForm.password.length < 8 || this.signUpForm.password.length > 20 ){
              callback(new Error('必须8-20位字符'));
              ls=0;
            }
            if(this.signUpForm.password.match(/([\u4E00-\u9FA5])+/)){
              callback(new Error('不能包含中文字符'));
              ls=0;
            }
            switch (ls) {
              case 0: this.passwordPercent = 0;callback(new Error('必须包含数字、大小写字母'));break;
              case 1: this.passwordPercent = 35;callback(new Error('必须包含数字、大小写字母'));break;
              case 2: this.passwordPercent = 65;callback(new Error('必须包含数字、大小写字母'));break;
              case 3: this.passwordPercent = 100;break;
              //case 4: this.passwordPercent = 100;break;
              default: this.passwordPercent = 0;break;
            }
          }
          callback();
        }
      };
      var validateCheckPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('please enter the password again'));
        } else if(value !== this.signUpForm.password){
          callback(new Error('the two passwords are inconsistent'));
        }else{
          callback();
        }
      };
      return {
        routeHidden: true,
        routerMode:true,
        //activeIndex: '/home' ,
        timeNow: '',
        loginOption: '登录',
        dialogVisible: false,
        dialogVisibleEdit: false,
        tipHidden: true,
        editTipHidden: true,
        userNowHidden: true,   //登录名显示
        loginForm: {
          username: '',
          password: ''
        },
        userNow: '',
        userInfoForm: {
          name: '',
          fullName: '',
          password: '',
          passwordEnsure: ''
        },
        rules: {
          password: [
            { validator: validatePass, trigger: 'blur' },
          ],
          fullName: [
            { validator: validateFullName, trigger: 'blur' },
          ],
          passwordEnsure: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          email: [
            { type: 'email',message:'Please enter the correct email address' ,trigger: ['blur','change'] },
          ],
          identifyValid: [
            { validator: identifyValidPass, trigger: 'blur' }
          ],
          identifyValidForget: [
            { validator: identifyValidPassForget, trigger: 'blur' }
          ],
          password:[{ validator: validateSignPass, trigger: 'blur' }],
          checkPass:[{ validator: validateCheckPass, trigger: 'blur' }]
        },
        divStyle: '',
        isManage:false,
        activetabName:'NSRL',
        identifyCode:'',
        identifyCodeForget:'',
        identifyCodes:'1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        signUpForm:{
          username: '',
          password:'',
          email:'',
          identifyValid:'',
          checkPass:'',
        },
        dialogForgetPassword:false,
        forgetForm:{
          email:'',
          identifyValidForget:''
        },
        passwordPercent:0,
        lastTime:null,// 最后一次点击的时间
        currentTime:null,// 当前点击的时间
        timeOut:30*60*1000,// 设置超时时间：30分钟,
        visitorCounter:0,
      }
    },
    computed: {
      activeIndex:{
        get:function() {
          return this.activeIndex = this.$route.path ? this.$route.path: '/home' ;
        },
        set:function(){}
      },
      showNavBar(){
        return this.$route.meta.showNavBar !== false //默认显示
      },
      showFooter(){
        return  this.$route.meta.showFooter !== false //默认显示
      },
      isShowPaddingno(){
        return !(this.$route.meta.showFooter !== false)
      }

    },
    created:function(){
      this.refreshCode('identifyCode');
      //window.setInterval(() => {
       //setTimeout(this.getTimerData, 0)
      //}, 2*60*1000);
      let token = window.sessionStorage.getItem('JWT_TOKEN');
      if(token == "null" || token === null || token == "undefined" || typeof(token) == undefined){
        token = this.$route.query.token;
      }
      if(token != "null" && token != "undefined" && typeof(token) != "undefined"){
        window.sessionStorage.setItem('JWT_TOKEN', token)
        //this.getUserInfo();
        if(this.$route.query.username && this.$route.query.username != "undefined"){
          window.sessionStorage.setItem('USER_NAME',decodeURIComponent(this.$route.query.username))
        }
        // 保存用户类型：cas（统一身份认证用户）或 local（本地数据库用户）
        if(this.$route.query.userType){
          window.sessionStorage.setItem('USER_TYPE', this.$route.query.userType)
        } else if(!window.sessionStorage.getItem('USER_TYPE')){
          // 如果URL中没有userType参数且sessionStorage中也没有，说明是本地登录用户
          window.sessionStorage.setItem('USER_TYPE', 'local')
        }
      }
    },
    mounted(){
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isAndroid || isiOS){
        this.divStyle = 'min-width: 1500px;'
      }else{
        this.divStyle = 'min-width: 1500px;'
      }

      let _this = this;
      
      let JWT_TOKEN = window.sessionStorage.getItem('JWT_TOKEN');
      if(JWT_TOKEN && JWT_TOKEN != 'null'){
        this.loginOption = '退出'
        this.userNow = window.sessionStorage.getItem('USER_NAME') == "null" ? ' ' : window.sessionStorage.getItem('USER_NAME');
        this.userNowHidden = false
        this.routeHidden = false
        if(window.sessionStorage.isManage === 'true'){
          this.isManage = true
        }else{
          this.isManage = false
        }
      }
      //this.$axios.post(this.urlFragment + '/account/test')
        //.then(function (response) {
          //console.log('then' + JSON.stringify(response))
          //if (response.headers['newtoken']) {
            //console.log("存在newToken")
            //_this.loginOption = 'Log out'
            //_this.userNow = window.sessionStorage.USER_NAME
            //_this.userNowHidden = false
            //_this.routeHidden = false
            //return
          //}
          //if(response.headers['ip-pass']){
            //_this.loginOption = 'Log in'
          //} else {
           // _this.loginOption = 'Log out'
            //_this.userNow = window.sessionStorage.USER_NAME
            //_this.userNowHidden = false
          //}
          //_this.routeHidden = false
        //}).catch(error => {
          //console.log(error)
        //_this.loginOption = 'Log in'
        //_this.routeHidden = true
     // })
      //手动刷新页面之后默认回到首页
     // this.$router.push("/home");
      this.defaultIndex();
         //声明一个变量指向Vue实例this，保证作用域一致
      this.timer = setInterval(function () {
        _this.timeNow = new Date().format("yyyy-MM-dd hh:mm:ss").toString();    //定时刷新页面时间
      },1000);
      this.getVisitorCounter();
    },
    methods: {
      getUserInfo(){
        this.$axios.post('/daku/public/getCurrentUserInfoByToken',{
              token: window.sessionStorage.getItem('JWT_TOKEN')
            }).then((response)=> {
                   window.sessionStorage.setItem('JWT_TOKEN', response.data.token)
                   window.sessionStorage.setItem('USER_NAME', response.data.displayName)
                   window.sessionStorage.setItem('user_id', response.data.id)
                   
                   //this.userNow = response.data.displayName;
                  
                   this.userRoles = response.data.roles;
                   window.sessionStorage.setItem('userRoles', JSON.stringify(response.data.roles));
                   
                  let roles = response.data.roles;
                  let str = '';
                  if(roles == "null" || roles == "undefined" || typeof(roles) == undefined){
                      return false;
                  }
                    
                    
          })
      },
      //页面初始化时，设置导航栏中的高亮
      defaultIndex(){
        this.activeIndex = this.$route.path ? this.$route.path: '/home' ;
      },
      //点击login按钮事件
      loginClick (flag) {
        let _this = this
        if (_this.loginOption === '退出') {
          //window.sessionStorage.clear()
          //获取用户类型
          let userType = window.sessionStorage.getItem('USER_TYPE')
          //如果是cas用户，先调用cas logout接口
          if(userType === 'cas'){
             // 方法1: 使用Image对象（通常不会被阻止）
                const img = new Image();
                img.src = 'https://nsrloa.ustc.edu.cn/cas/logout';
                img.onerror = () => console.log("CAS logout image request completed");
                img.onload = () => console.log("CAS logout image loaded");

                // 方法2: 使用fetch API（可能有CORS限制，但尝试一下）
                try {
                    fetch('https://nsrloa.ustc.edu.cn/cas/logout', {
                        mode: 'no-cors',
                        credentials: 'include'
                    }).then(() => {
                        console.log("CAS logout fetch completed");
                    }).catch(err => {
                        console.log("CAS logout fetch error (expected):", err);
                    });
                } catch(e) {
                    console.log("Fetch not supported or blocked");
                }

                // 方法3: 仍然尝试iframe（以防某些浏览器支持）
                const casIframe = document.createElement('iframe');
                casIframe.style.display = 'none';
                casIframe.style.width = '0';
                casIframe.style.height = '0';
                casIframe.src = 'https://nsrloa.ustc.edu.cn/cas/logout';
                document.body.appendChild(casIframe);

                console.log("All CAS logout methods initiated");

                // 延迟清理iframe
                setTimeout(() => {
                    // 清理iframe
                    if(casIframe && casIframe.parentNode) {
                        casIframe.parentNode.removeChild(casIframe);
                    }
                }, 1000);
          }
          this.$axios.post('/hlsTS/hlsii/pub/logout')
            .then(function (response) {
              _this.$message({
                message: '已退出登录',
                type: 'success'
              })
              _this.userNowHidden = true
              _this.userNow = ''
              _this.loginForm = {
                username: '',
                password: ''
              }
              if(response.headers['ip-pass']){
                _this.loginOption = '登录'
              } else {
                _this.loginOption = '登录'
                _this.$router.push('/home')
                _this.routeHidden = true
              }
              _this.routeHidden = true
              // 清除所有session storage数据
              window.sessionStorage.removeItem('JWT_TOKEN')
              window.sessionStorage.removeItem('USER_NAME')
              window.sessionStorage.removeItem('USER_TYPE')
              window.sessionStorage.removeItem('isManage')
            }).catch(error => {
            console.log(error)
            _this.$router.push('/home')
            _this.routeHidden = true
            _this.loginOption = '登录'
            _this.userNowHidden = true
            _this.userNow = ''
            // 清除所有session storage数据
            window.sessionStorage.removeItem('JWT_TOKEN')
            window.sessionStorage.removeItem('USER_NAME')
            window.sessionStorage.removeItem('USER_TYPE')
            window.sessionStorage.removeItem('isManage')
          })
        } else {
          if(_this.loginOption === '登录'){
            _this.activetabName = 'NSRL';
          }
          if(flag === '注册'){
            _this.activetabName = '注册';
          }
          _this.dialogVisible = true;
        }
      },
      //用户登录
      login (formName) {
        this.$refs[formName].validate((valid) =>{
          if(valid){
            this.tipHidden = true
            let _this = this
            let loginForm = this.loginForm
            this.$axios.post('/hlsTS/hlsii/pub/login', {
              name: loginForm.username,
              pwd: loginForm.password
            }).then(function (response) {
              if (response.data.code === 0){
                _this.routeHidden = false
                _this.userNow = loginForm.username
                _this.userNowHidden = false
                _this.$router.push({path: '/home'})
                window.sessionStorage.setItem('JWT_TOKEN', response.data.data.session_id)
                window.sessionStorage.setItem('USER_NAME', loginForm.username)
                // 设置为本地用户类型
                window.sessionStorage.setItem('USER_TYPE', 'local')
                if(response.data.data.role == 1){//管理员
                    _this.isManage = true
                }else if(response.data.data.role == 2){//普通用户
                    _this.isManage = false
                }
                window.sessionStorage.setItem('isManage', _this.isManage)
                _this.userInfoForm.name = loginForm.username
                _this.loginOption = '退出'
                _this.$message({
                  message: '登录成功',
                  type: 'success'
                })
                _this.loginForm = {
                  username: '',
                  password: ''
                }
                _this.tipHidden = true
                // _this.$router.push({path: '/user'})
                _this.dialogVisible = false
              }
              if(response.data.code === -3){
                _this.$message(response.data.msg);
              }
          }).catch(function (error) {
            _this.tipHidden = false
            console.log(error)
          })
          }
        })
      },
      //修改用户信息
      editUserInfo () {
        let pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (this.userInfoForm.fullName == '' || this.userInfoForm.password.length < 8 || this.userInfoForm.password !== this.userInfoForm.passwordEnsure){
          this.editTipHidden = false
          return
        }else {
          this.editTipHidden = true
        }
        let _this = this
        this.editTipHidden = true
        this.dialogVisibleEdit = true
        this.$axios.post(this.urlFragment + '/account/info', {
          name: this.userInfoForm.name,
          fullName: this.userInfoForm.fullName,
          passWord: this.userInfoForm.password,
        })
          .then(function (response) {
            if (response.data === true) {
              _this.dialogVisibleEdit = false
              _this.routeHidden = false
              _this.loginOption = '退出'
            } else {
              _this.editTipHidden = false
            }
          })
          .catch(error => {
            _this.editTipHidden = false
          })
      },
      handleClose(done) {
        window.sessionStorage.setItem('JWT_TOKEN', null)
        this.userNow = ''
        this.userNowHidden = true
        done()
      },
      select(index,indexPath){
        if(index == "2-5"){
          window.open('http://192.168.113.81:7180/cmf/home');
        }else{
          this.$router.push({path:index})
        }
      },
      randomNum(min,max){
        return Math.floor(Math.random() * (max - min) + min)
      },
      refreshCode(option){
        if(option === 'identifyCode'){
          this.identifyCode = '';
        }else if(option === 'identifyCodeForget'){
          this.identifyCodeForget = '';
        }
        this.makeCode(option,this.identifyCodes,4);
      },
      makeCode(option,k,length){
        for(let i=0;i<length;i++){
          if(option === 'identifyCode'){
            this.identifyCode += this.identifyCodes[this.randomNum(0,this.identifyCodes.length)]
          }else if(option === 'identifyCodeForget'){
            this.identifyCodeForget += this.identifyCodes[this.randomNum(0,this.identifyCodes.length)]
          }
        }
      },
      //用户注册
      signUp(formName){
        this.$refs[formName].validate((valid) =>{
          if(valid){
            this.$axios.post('/hlsTS/hlsii/pub/signUp/' + this.signUpForm.username + '/' + this.signUpForm.password  + '/' + this.signUpForm.email)
            .then((response) => {
              if (response.data.success === true) {
                this.$message(response.data.message);
                this.clearForm();
                this.dialogVisible = false;
              } else {
                this.$message(response.data.message);
                this.dialogVisible = true;
              }
            })
            .catch((error) => {
              this.dialogVisible = true;
            })
          }
        })
      },
      clearForm(){
        this.signUpForm.username = '';
        this.signUpForm.password = '';
        this.signUpForm.email = '';
        this.signUpForm.identifyValid = '';
        this.signUpForm.checkPass = '';
        this.loginForm.username = '';
        this.loginForm.password = '';
        this.passwordPercent = 0;
      },
      //忘记密码
      forgetPassword(){
        this.forgetForm.email= '';
        this.forgetForm.identifyValidForget= '';
        this.dialogForgetPassword = true;
        this.refreshCode('identifyCodeForget');
      },
      //无法登录
      loginMatter(){
        this.$alert(
          '<div style="text-align: center; padding: 20px 10px;">' +
            '<i class="el-icon-question" style="font-size: 60px; color: #E6A23C; margin-bottom: 15px;"></i>' +
            '<p style="font-size: 15px; color: #606266; line-height: 1.8; margin: 15px 0;">如果您无法登录，请联系系统管理员</p>' +
            '<div style="background: #f5f7fa; padding: 15px; border-radius: 8px; margin-top: 20px;">' +
              '<p style="font-size: 14px; color: #303133; margin: 8px 0;"><i class="el-icon-message" style="color: #409EFF; margin-right: 5px;"></i> sunxk@ustc.edu.cn</p>' +
              '<p style="font-size: 14px; color: #303133; margin: 8px 0;"><i class="el-icon-message" style="color: #409EFF; margin-right: 5px;"></i> yfgan@ustc.edu.cn</p>' +
            '</div>' +
          '</div>',
          '联系管理员',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '我知道了',
            customClass: 'contact-admin-dialog',
            center: false
          }
        );
      },
      //找回密码
      togetPassword(formName){
        this.$refs[formName].validate((valid) =>{
          if(valid){
            this.$axios.post('/hlsTS/hlsii/pub/findUserAndPwd/'+ this.forgetForm.email)
            .then((response) => {
              if(response.data.success){
                this.$message(response.data.message);
              }
              this.dialogForgetPassword = false;
            })
            .catch((error) => {
              this.dialogForgetPassword = true;
            })
          }
        })
      },
      passwordPercentFormat(percentage){
        if(percentage === 0){
          return '';
        }else if(percentage < 50){
          return '弱';
        }else if(percentage > 80){
          return '强';
        }else{
          return '中';
        }
      },
      customColorMethod(percentage){
        if(percentage < 50){
          return 'red'
        }else if(percentage > 80){
          return 'green'
        }else {
          return 'orange'
        }
      },
      //判断是否长时间未操作
      isTimeOut(){
        this.currentTime = new Date().getTime();// 记录这次点击的时间
        if(this.currentTime - this.lastTime > this.timeOut){
          if(window.sessionStorage.getItem('JWT_TOKEN') !== null){// 登录状态或者token失效，token里都有值
            this.userNowHidden = true
            this.userNow = ''
            this.loginForm = {
                username: '',
                password: ''
            }
            this.routeHidden = true
            this.loginOption = '登录'
            this.dialogVisible = true
            window.sessionStorage.removeItem('JWT_TOKEN');
            window.sessionStorage.removeItem('USER_NAME');
            window.sessionStorage.setItem('isManage', false);
            this.$router.push({path: '/home'});
          }else{
            this.lastTime = new Date().getTime();
          }
        }else{
          this.lastTime = new Date().getTime(); //如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
        }
      },
      getTimerData(){
        this.$axios.get('/hlsTS/hlsii/pub/needLogin');
      },
      getVisitorCounter(){
        this.$axios.get('/hlsTS/hlsii/pub/getVisitorCounter').then((response)=> {
          this.visitorCounter = response.data; 
        }).catch(()=>{
          this.visitorCounter = 0; 
        })
        
      }
    },
    //在页面跳转之前销毁定时器，防止一直获取24小时的流强和寿命数据
    beforeDestory:function () { //清除定时器
      if (this.timer){
        clearInterval(this.timer);  //在Vue实例销毁前，清除定时器
      }
    },
  }

</script>

<style scoped>
  .grid-content{
    border-radius:4px;
    min-height:36px;
  }
  .bg-purple{
    background:#d3dce6;
  }
  .bg-purple-light{
    background:#e5e9f2;
  }
  .menu{
    width:200px;
    min-height: 36px;
  }
  .menu-flex .el-menu-item{padding: 0 5px!important;}
  /deep/.menu-flex .el-submenu .el-submenu__title{padding: 0 5px!important;}
  /deep/.menu-flex .el-submenu .el-submenu__title .el-submenu__icon-arrow{right: 10px!important;}
  .menu-item-box{width:180px!important}
  a {
    text-decoration: none;
    color: white;
  }
  .is-active a{
    color: rgb(255, 208, 75);
    background-color: rgb(0, 68, 153);
  }
  .routernav{
    text-decoraction: none;
  }

  /* ========== 导航栏美化样式 ========== */

  /* 导航栏整体样式 */
  .el-menu-demo {
    //border-bottom: 4px solid #ffd04b !important;
    box-shadow: 0 4px 16px rgba(0, 68, 153, 0.2), 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    background: linear-gradient(180deg, #004499 0%, #003875 100%) !important;
    position: relative;
  }

  /* 导航栏顶部光泽效果 */
  .el-menu-demo::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 208, 75, 0.5) 50%, transparent 100%);
  }

  /* 导航栏菜单项通用样式 */
  .el-menu-item,.el-submenu {
    border-left: 2px solid transparent !important;
    border-right: 2px solid transparent !important;
    font-size: 15px !important;
    font-family: Arial, Helvetica, sans-serif;
    text-decoration: none;
    font-weight: 600 !important;
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
    position: relative;
    margin: 0 2px;
  }

  /* 菜单项发光效果（初始隐藏） */
  .el-menu-item::before,
  /deep/ .el-submenu__title::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, rgba(255, 208, 75, 0.15) 0%, transparent 70%);
    opacity: 0;
    transition: opacity 0.35s ease;
  }

  /* 菜单项悬停效果 */
  .el-menu-item:hover,
  /deep/ .el-submenu__title:hover {
    background: linear-gradient(180deg, #0056b3 0%, #004499 100%) !important;
    border-left-color: #ffd04b !important;
    border-right-color: #ffd04b !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 208, 75, 0.3);
  }

  .el-menu-item:hover::before,
  /deep/ .el-submenu__title:hover::before {
    opacity: 1;
  }

  /* 激活菜单项样式 */
  .el-menu-item.is-active {
    background: linear-gradient(180deg, #0056b3 0%, #003366 100%) !important;
    border-left-color: #ffd04b !important;
    border-right-color: #ffd04b !important;
    position: relative;
    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.2), 0 4px 12px rgba(255, 208, 75, 0.4);
  }

  .el-menu-item.is-active::before {
    opacity: 1;
  }

  /* 激活菜单项底部指示器 */
  .el-menu-item.is-active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 85%;
    height: 4px;
    //background: linear-gradient(90deg, transparent 0%, #ffd04b 20%, #ffd04b 80%, transparent 100%);
    border-radius: 2px 2px 0 0;
    box-shadow: 0 -2px 8px rgba(255, 208, 75, 0.6);
    animation: glow 2s ease-in-out infinite;
  }

  @keyframes glow {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  /* 子菜单标题样式 */
  /deep/ .el-submenu__title {
    font-weight: 600 !important;
    font-size: 15px !important;
  }

  /* 展开的子菜单高亮效果 */
  /deep/ .el-submenu.is-opened > .el-submenu__title {
    background: linear-gradient(180deg, #0056b3 0%, #004499 100%) !important;
    border-left-color: #ffd04b !important;
    border-right-color: #ffd04b !important;
  }

  /* 下拉菜单样式优化 */
  /deep/ .el-menu--popup {
    min-width: 190px !important;
    border-radius: 10px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 4px 12px rgba(0, 68, 153, 0.12) !important;
    border: 1px solid rgba(228, 231, 237, 0.8) !important;
    padding: 10px 0 !important;
    background: #ffffff !important;
    backdrop-filter: blur(10px);
    animation: dropdownSlide 0.3s ease-out;
  }

  @keyframes dropdownSlide {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /deep/ .el-menu--popup .el-menu-item {
    font-size: 14px !important;
    padding: 0 20px !important;
    height: 42px !important;
    line-height: 42px !important;
    border: none !important;
    margin: 3px 10px !important;
    border-radius: 7px !important;
    transition: all 0.25s ease !important;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-menu--popup .el-menu-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 0;
    background: linear-gradient(180deg, #409EFF 0%, #004499 100%);
    transition: height 0.25s ease;
    border-radius: 0 2px 2px 0;
  }

  /deep/ .el-menu--popup .el-menu-item:hover {
    background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%) !important;
    color: #004499 !important;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
  }

  /deep/ .el-menu--popup .el-menu-item:hover::before {
    height: 70%;
  }

  /deep/ .el-menu--popup .el-submenu__title {
    padding: 0 20px !important;
    height: 42px !important;
    line-height: 42px !important;
    border: none !important;
    margin: 3px 10px !important;
    border-radius: 7px !important;
    transition: all 0.25s ease !important;
  }

  /deep/ .el-menu--popup .el-submenu__title:hover {
    background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%) !important;
    color: #004499 !important;
    transform: translateX(4px);
  }

  /* Logo区域优化 */
  .logo {
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
  }

  /*.logo::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
    transform: rotate(45deg);
    transition: all 0.6s ease;
    opacity: 0;
  }*/

 /* .logo:hover {
    transform: scale(1.08) rotate(5deg);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25), 0 3px 8px rgba(255, 208, 75, 0.3);
  }

  .logo:hover::after {
    opacity: 1;
    top: 100%;
    left: 100%;
  }*/

  /* 时间显示优化 */
  .logo + p {
    font-weight: 600 !important;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background: linear-gradient(135deg, #2d6ba9 0%, #1e4a7a 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  /* 用户信息区域优化 */
  .userInfo {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .userInfo:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  .userInfo .el-icon-user-solid {
    font-size: 18px;
    color: #67c23a;
    animation: userIconPulse 2s ease-in-out infinite;
  }

  @keyframes userIconPulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
  }

  .userInfo span {
    transition: all 0.3s ease;
  }

  .userInfo span:hover {
    transform: scale(1.05);
  }

  /* 二级子菜单容器样式 */
  /deep/ .el-menu--popup .el-menu--popup {
    min-width: 190px !important;
    border-radius: 10px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 4px 12px rgba(0, 68, 153, 0.12) !important;
    border: 1px solid rgba(228, 231, 237, 0.8) !important;
    padding: 10px 0 !important;
    background: #ffffff !important;
    backdrop-filter: blur(10px);
    animation: dropdownSlide 0.3s ease-out;
    margin-left: 10px !important;
    margin-top: -8px !important;
  }

  /* 三级子菜单项样式 - 与二级菜单相同 */
  /deep/ .el-menu--popup .el-menu--popup .el-menu-item {
    font-size: 14px !important;
    padding: 0 20px !important;
    height: 42px !important;
    line-height: 42px !important;
    border: none !important;
    margin: 3px 10px !important;
    border-radius: 7px !important;
    transition: all 0.25s ease !important;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-menu--popup .el-menu--popup .el-menu-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 0;
    background: linear-gradient(180deg, #409EFF 0%, #004499 100%);
    transition: height 0.25s ease;
    border-radius: 0 2px 2px 0;
  }

  /deep/ .el-menu--popup .el-menu--popup .el-menu-item:hover {
    background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%) !important;
    color: #004499 !important;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
  }

  /deep/ .el-menu--popup .el-menu--popup .el-menu-item:hover::before {
    height: 70%;
  }

  /* 一级子菜单中的二级submenu标题样式优化 */
  /deep/ .el-menu--popup .el-submenu .el-submenu__title {
    //background: linear-gradient(135deg, #f0f7ff 0%, #e8f4ff 100%) !important;
    color: #004499 !important;
    font-weight: 600;
    border-left: 4px solid #409EFF !important;
    padding: 0 20px !important;
    margin: 2px 0 !important;
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 0 !important;
    white-space: nowrap;
  }

  /deep/ .el-menu--popup .el-submenu .el-submenu__title:hover {
    //background: linear-gradient(135deg, #e3f2fd 0%, #d1e9ff 100%) !important;
    border-left-color: #004499 !important;
    box-shadow: inset 0 0 0 1px rgba(64, 158, 255, 0.2);
  }

  /deep/ .el-menu--popup .el-submenu.is-opened > .el-submenu__title {
    //background: linear-gradient(135deg, #d1e9ff 0%, #bbdefb 100%) !important;
    border-left-color: #004499 !important;
    box-shadow: inset 0 1px 3px rgba(0, 68, 153, 0.15), inset 0 0 0 1px rgba(64, 158, 255, 0.3);
  }

  /* 二级子菜单的箭头图标 */
  /deep/ .el-menu--popup .el-submenu .el-submenu__icon-arrow {
    color: #409EFF !important;
    font-size: 13px;
  }

  /deep/ .el-menu--popup .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    color: #004499 !important;
  }

  /* 菜单图标样式 */
  /deep/ .el-submenu__icon-arrow {
    font-weight: bold;
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }

  /* 展开时箭头旋转 */
  /deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotateZ(180deg);
    color: #ffd04b !important;
  }

  /* 头部区域整体优化 */
  .headerBox {
    //background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
    //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    position: relative;
  }

  .headerBox::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    //background: linear-gradient(90deg, transparent 0%, rgba(0, 68, 153, 0.2) 50%, transparent 100%);
  }

  /* 响应式优化 */
  @media (max-width: 1440px) {
    .el-menu-item,.el-submenu {
      font-size: 14px !important;
      padding: 0 10px !important;
    }

    .menu-item-box {
      width: 160px !important;
    }

    .userInfo {
      padding: 6px 12px;
      font-size: 14px;
    }
  }

  @media (max-width: 1200px) {
    .el-menu-item,.el-submenu {
      font-size: 13px !important;
      padding: 0 8px !important;
    }

    .menu-item-box {
      width: 140px !important;
    }
  }

  /* ========== 导航栏美化样式结束 ========== */

  /* 强制三级菜单样式与二级菜单一致 */
  /deep/ .el-menu--horizontal > .el-menu-item .el-menu--popup .el-menu--popup,
  /deep/ .el-menu--horizontal > .el-submenu .el-menu--popup .el-menu--popup {
    min-width: 190px !important;
    border-radius: 10px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 4px 12px rgba(0, 68, 153, 0.12) !important;
    border: 1px solid rgba(228, 231, 237, 0.8) !important;
    padding: 10px 0 !important;
    background: #ffffff !important;
    backdrop-filter: blur(10px);
  }

  /deep/ .el-menu--horizontal > .el-menu-item .el-menu--popup .el-menu--popup .el-menu-item,
  /deep/ .el-menu--horizontal > .el-submenu .el-menu--popup .el-menu--popup .el-menu-item {
    font-size: 14px !important;
    padding: 0 20px !important;
    height: 42px !important;
    line-height: 42px !important;
    border: none !important;
    margin: 3px 10px !important;
    border-radius: 7px !important;
    transition: all 0.25s ease !important;
  }

  /deep/ .el-menu--horizontal > .el-menu-item .el-menu--popup .el-menu--popup .el-menu-item::before,
  /deep/ .el-menu--horizontal > .el-submenu .el-menu--popup .el-menu--popup .el-menu-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 0;
    background: linear-gradient(180deg, #409EFF 0%, #004499 100%);
    transition: height 0.25s ease;
    border-radius: 0 2px 2px 0;
  }

  /deep/ .el-menu--horizontal > .el-menu-item .el-menu--popup .el-menu--popup .el-menu-item:hover,
  /deep/ .el-menu--horizontal > .el-submenu .el-menu--popup .el-menu--popup .el-menu-item:hover {
    background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%) !important;
    color: #004499 !important;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
  }

  /deep/ .el-menu--horizontal > .el-menu-item .el-menu--popup .el-menu--popup .el-menu-item:hover::before,
  /deep/ .el-menu--horizontal > .el-submenu .el-menu--popup .el-menu--popup .el-menu-item:hover::before {
    height: 70%;
  }

  .el-menu-item{
    width: 100%;
  }

  .template{
    font-size: large;
  }

  .router-link-active {
    text-decoration: none;
  }
  .content{
    height:auto;
    min-height:100%;
    width:100%;
  }
  .wrapBox{
    padding-bottom:150px;
    padding-top: 20px;
    margin-bottom: 20px;
    background: #eef3f7;
  }
  .el-footer {
    font-style: normal;
    color: #5b5b5b;
    text-align: center;
    font-size: large;
    margin:0 auto;
    width:1400px;
    font-size: 14px;
  }
  .footBox{
    position:relative;
    padding: 1em;
    line-height: 2;
    height:100px!important;
    margin-top:-100px;
  }
  .footBox a{ 
    color: #5b5b5b;
  }
  .footBox:before {
    content: '';
    display: block;
    width: 200px;
    margin: 0 auto 30px;
    height: 0px;
    background: #d6dade;
  }
  .identify{
    float: right;
    width:100px;
    height:38px;
    border:1px solid red;
    border-radius:4px;
    cursor:pointer;
  }
  .paddingno{
    padding-bottom:0px!important;
  }
  /deep/.el-form .el-form-item__label{
    line-height:30px!important;
  }
  /deep/.el-form .el-form-item.is-success .el-input__inner{
    border-color:#409EFF!important;
  }

  /* ========== 登录页面美化样式 ========== */

  /* 登录遮罩层 */
  .login-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
    z-index: 2000;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* 登录对话框样式 */
  /deep/ .login-dialog {
    border-radius: 16px !important;
    box-shadow: 0 12px 48px rgba(0, 68, 153, 0.15) !important;
    overflow: hidden;
    animation: slideDown 0.4s ease;
  }

  @keyframes slideDown {
    from {
      transform: translateY(-50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  /deep/ .login-dialog .el-dialog__header {
    padding: 25px 30px 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
    border-bottom: 1px solid #e4e7ed;
  }

  /deep/ .login-dialog .el-dialog__body {
    padding: 0;
    background: #ffffff;
  }

  .login-dialog-title h2 {
    font-size: 22px;
    letter-spacing: 1px;
  }

  /* Tabs样式优化 */
  .login-tabs /deep/ .el-tabs__header {
    margin: 0;
    background: #f8f9fa;
    padding: 0 20px;
  }

  .login-tabs /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }

  .login-tabs /deep/ .el-tabs__item {
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    font-weight: 500;
    color: #606266;
    transition: all 0.3s;
  }

  .login-tabs /deep/ .el-tabs__item:hover {
    color: #409EFF;
  }

  .login-tabs /deep/ .el-tabs__item.is-active {
    color: #004499;
    font-weight: 600;
  }

  .login-tabs /deep/ .el-tabs__active-bar {
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #004499 100%);
  }

  /* CAS登录图标样式 */
  .cas-icon-wrapper {
    margin: 30px 0 40px;
    position: relative;
  }

  .icon-circle {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    border-radius: 50%;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 24px rgba(64, 158, 255, 0.25);
    animation: pulse 2s ease-in-out infinite;
    position: relative;
  }

  .icon-circle::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border-radius: 50%;
    border: 2px solid rgba(64, 158, 255, 0.3);
    animation: ripple 2s ease-out infinite;
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }

  @keyframes ripple {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1.3);
    }
  }

  /* CAS登录按钮 */
  .cas-login-btn {
    width: 330px !important;
    height: 45px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    background: linear-gradient(135deg, #409EFF 0%, #004499 100%) !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4) !important;
    transition: all 0.3s ease !important;
  }

  .cas-login-btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5) !important;
  }

  .cas-login-btn:active {
    transform: translateY(0) !important;
  }

  /* 全宽按钮样式 */
  .full-width-btn {
    width: 100% !important;
    height: 42px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    background: linear-gradient(135deg, #409EFF 0%, #004499 100%) !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3) !important;
    transition: all 0.3s ease !important;
  }

  .full-width-btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4) !important;
  }

  .full-width-btn:active {
    transform: translateY(0) !important;
  }

  /* 输入框样式优化 */
  .login-tabs /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    border: 1px solid #DCDFE6;
    transition: all 0.3s;
    font-size: 14px;
  }

  .login-tabs /deep/ .el-input__inner:focus {
    border-color: #409EFF;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
  }

  .login-tabs /deep/ .el-input__prefix {
    left: 12px;
    font-size: 16px;
    color: #909399;
  }

  .login-tabs /deep/ .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }

  /* 链接文字样式 */
  .link-text {
    font-size: 13px;
    color: #409EFF;
    cursor: pointer;
    transition: all 0.3s;
  }

  .link-text:hover {
    color: #004499;
    text-decoration: underline;
  }

  /* 表单标签样式 */
  .login-tabs /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
    height: 40px;
    display: flex;
    align-items: center;
  }

  /* 密码强度进度条美化 */
  .login-tabs /deep/ .el-progress-bar__outer {
    border-radius: 4px;
    background-color: #f0f0f0;
  }

  .login-tabs /deep/ .el-progress-bar__inner {
    border-radius: 4px;
  }

  /* 验证码样式优化 */
  .identify {
    width: 100px;
    height: 38px;
    border: 1px solid #DCDFE6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s;
    overflow: hidden;
  }

  .identify:hover {
    border-color: #409EFF;
    box-shadow: 0 0 8px rgba(64, 158, 255, 0.2);
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    /deep/ .login-dialog {
      width: 90% !important;
      margin: 0 5% !important;
    }
  }

  /* ========== 登录页面美化样式结束 ========== */

  /* ========== 忘记密码弹出框样式 ========== */
  /deep/ .forget-password-dialog {
    border-radius: 12px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
  }

  /deep/ .forget-password-dialog .el-dialog__header {
    padding: 20px 30px 15px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
    border-bottom: 1px solid #e4e7ed;
  }

  /deep/ .forget-password-dialog .el-dialog__body {
    padding: 25px 20px 30px;
  }

  .dialog-custom-title {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ========== 联系管理员弹出框样式 ========== */
  /deep/ .contact-admin-dialog {
    border-radius: 12px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
    width: 400px !important;
  }

  /deep/ .contact-admin-dialog .el-message-box__header {
    padding: 20px 20px 15px;
    background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
    border-bottom: 1px solid #f5e5c7;
  }

  /deep/ .contact-admin-dialog .el-message-box__title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }

  /deep/ .contact-admin-dialog .el-message-box__content {
    padding: 10px 20px 25px;
  }

  /deep/ .contact-admin-dialog .el-message-box__btns {
    padding: 10px 20px 20px;
  }

  /deep/ .contact-admin-dialog .el-button--primary {
    background: linear-gradient(135deg, #409EFF 0%, #004499 100%) !important;
    border: none !important;
    padding: 10px 30px !important;
    border-radius: 6px !important;
    font-weight: 500 !important;
  }

  /deep/ .contact-admin-dialog .el-button--primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4) !important;
  }

  /* ========== 弹出框样式结束 ========== */

</style>

<style>
/* 全局菜单样式 - 不使用scoped以便应用到动态渲染的菜单 */

/* 三级子菜单容器样式 - 与二级菜单相同 */
.el-menu--popup .el-menu--popup {
  min-width: 190px !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 4px 12px rgba(0, 68, 153, 0.12) !important;
  border: 1px solid rgba(228, 231, 237, 0.8) !important;
  padding: 10px 0 !important;
  background: #004499 !important;
  backdrop-filter: blur(10px);
  animation: dropdownSlide 0.3s ease-out;
}

/* 三级子菜单项样式 - 与二级菜单相同 */
.el-menu--popup .el-menu--popup .el-menu-item {
  font-size: 14px !important;
  padding: 0 20px !important;
  height: 42px !important;
  line-height: 42px !important;
  border: none !important;
  margin: 3px 0px !important;
  border-radius: 7px !important;
  transition: all 0.25s ease !important;
  position: relative;
  overflow: hidden;
}

.el-menu--popup .el-menu--popup .el-menu-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: linear-gradient(180deg, #409EFF 0%, #004499 100%);
  transition: height 0.25s ease;
  border-radius: 0 2px 2px 0;
}

.el-menu--popup .el-menu--popup .el-menu-item:hover {
  background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%) !important;
  color: #004499 !important;
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
}

.el-menu--popup .el-menu--popup .el-menu-item:hover::before {
  height: 70%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue